module.exports = __webpack_public_path__ + "img/laminas.46a46f55.jpg";